import React from "react";

const ParcelPointHeader = () => {
    return (
        <React.Fragment>
            <p className="text-sm text-[#2B549A] font-semibold mt-3">
                Choose your preferred delivery option:
            </p>
            <ul className="list-disc list-inside text-sm text-[#2B549A] mt-2 text-left">
                <li>Send to another Point network</li>
                <li>Drop off at one of our lockers</li>
                <li>Deliver directly to a door</li>
                <li>Use our convenient kiosk network</li>
            </ul>
        </React.Fragment>
    )
}

export default ParcelPointHeader;